import { render, staticRenderFns } from "./MoneyColumn.vue?vue&type=template&id=91c4f90a&"
import script from "./MoneyColumn.vue?vue&type=script&lang=js&"
export * from "./MoneyColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports